import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76596f4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "role" }
const _hoisted_2 = { class: "menu-tree" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { nextTick, ref } from 'vue'
import { getListData } from '@/service/main/system'
import { ElTree } from 'element-plus'
import { menuMapLeafKeys } from '@/utils/map-menus'
import { getListByRole } from '@/service/main/permission/permission'

import { initEmptyParam } from '@/hooks/useInitParam'


export default /*#__PURE__*/_defineComponent({
  __name: 'role',
  setup(__props) {

initEmptyParam()

const permissions = ref<any[]>([])
const elTreeRef = ref<InstanceType<typeof ElTree>>()

const getAllPermission = async () => {
  let data = await getListData('/main/permission/listAll', {})

  permissions.value = data.list
}

getAllPermission()

const otherInfo = ref({})

const handleCheckChange = (data1: any, data2: any) => {
  const checkedKeys = data2.checkedKeys
  const halfCheckedKeys = data2.halfCheckedKeys
  const menuList = [...checkedKeys, ...halfCheckedKeys]
  otherInfo.value = { permissionIds: menuList }
}

const modalTitle = ref('新增')

const newCb = () => {
  modalTitle.value = '新增角色'
}

const editCb = (item: any) => {
  modalTitle.value = '编辑角色'
  if (item.roleName === 'ADMIN') {
    const leafKeys = menuMapLeafKeys(permissions.value)
    otherInfo.value = { permissionIds: leafKeys }
    nextTick(() => {
      elTreeRef.value?.setCheckedKeys(leafKeys, false)
    })
  } else {
    getPermissions(item.id)
  }
}

const getPermissions = async (roleId: string) => {
  const data = await getListByRole(roleId)
  const leafKeys = menuMapLeafKeys(data)
  nextTick(() => {
    elTreeRef.value?.setCheckedKeys(leafKeys, false)
    const checkedKeys = elTreeRef.value!.getCheckedKeys(false)
    const halfCheckedKeys = elTreeRef.value!.getHalfCheckedKeys()
    const menuList = [...checkedKeys, ...halfCheckedKeys]
    otherInfo.value = { permissionIds: menuList }
  })
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "role",
      deleteTip: "确认删除此角色吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, {
      status: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "mini",
          plain: "",
          type: scope.row.status == 1 ? 'success' : 'danger'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.status == 1 ? '正常' : '禁用'), 1)
          ]),
          _: 2
        }, 1032, ["type"])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "role",
      otherInfo: otherInfo.value,
      validOtherInfo: () => true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(ElTree), {
            ref_key: "elTreeRef",
            ref: elTreeRef,
            data: permissions.value,
            "show-checkbox": "",
            "node-key": "id",
            props: { children: 'permissions', label: 'name' },
            onCheck: handleCheckChange
          }, null, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})